export default "__VITE_ASSET__8900d018__"